// extracted by mini-css-extract-plugin
export default {"categoria":"SessaoPorCategoria_categoria__FtlZy","videos":"SessaoPorCategoria_videos__TtKv2"};